import dayjs from "dayjs";

dayjs.locale("zh-cn");

export default dayjs;
